import { API_BASE_URL } from "@/lib/common/config";
import type { HTTPEnvironment } from "@/lib/http";
import { useAuthState } from "@/lib/state";
import { useMemo } from "react";
import { useNavigate } from "react-router";

export const useAppHTTPEnvironment = (): HTTPEnvironment => {
	const { state, dispatchAuthLoggedIn } = useAuthState();
	const navigate = useNavigate();

	return useMemo(() => {
		return {
			getAccessToken: () => state.accessToken || null,
			setAccessToken: dispatchAuthLoggedIn,
			enableMaintenanceMode: () => navigate("/maintenance"),
			getApiBaseUrl: () => API_BASE_URL
		};
	}, [state.accessToken, dispatchAuthLoggedIn, navigate]);
};
